import * as API from "../";
export default {
  getList: (params) => {
    return API.GET("/api/deviceEvent/pagelist", params);
  },
  getEventDetail: (params) => {
    return API.GET("/api/deviceEvent/getEventDetail", params);
  },
  getPushList: (params) => {
    return API.GET("/api/deviceEvent/getPushList", params);
  },
  rePush: (params) => {
    return API.postJsonRequest("/api/deviceEvent/rePush", params);
  },
  updateState: (params) => {
    return API.postJsonRequest("/api/deviceEvent/updateState", params);
  },
  reportstate: (params) => {
    return API.postJsonRequest("/api/deviceEvent/reportState", params);
  }
};



// WEBPACK FOOTER //
// ./src/api/device/api_event.js